<ion-menu contentId="main-content">
  <ion-content class="ion-padding">
    <!-- USER INFO SECTION -->
    <div class="user-info">
      <ion-item lines="none">
        <ion-label>
          <p class="riderName">{{ riderName }}</p>
          <p class="riderContact">{{ riderContact }}</p>
        </ion-label>
      </ion-item>
    </div>

    <!-- LINE SEPARATOR -->
    <div class="line-container">
      <div class="hr"></div>
    </div>

    <!-- MENU ITEMS -->
    <div class="menu">
      <ion-menu-toggle autoHide="false">
        <ion-list lines="none" class="menu-list">
          <ion-item button class="menu-item" (click)="navigateToRoute('rider-dashboard')">
            <ion-icon name="home-outline" slot="start" class="primary-color"></ion-icon>
            <ion-label>Home</ion-label>
          </ion-item>
          <ion-item button class="menu-item" (click)="navigateToRoute('job-history')">
            <ion-icon name="document-text-outline" slot="start" class="primary-color"></ion-icon>
            <ion-label>Job History</ion-label>
          </ion-item>
          <ion-item button class="menu-item" (click)="logout()">
            <ion-icon name="log-out-outline" slot="start" class="primary-color"></ion-icon>
            <ion-label>Logout</ion-label>
          </ion-item>
        </ion-list>
      </ion-menu-toggle>
    </div>
  </ion-content>
</ion-menu>

<div class="ion-page" id="main-content"></div>
